import React from 'react';

const Loading = (props) => (
  <div style={{ margin: 5, fontWeight: '500', textAlign: 'center' }} {...props}>
    Loading...
  </div>
);

export default Loading;
